import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-facet-checkbox-filter',
  templateUrl: './facet-checkbox-filter.component.html',
  styleUrls: ['./facet-checkbox-filter.component.scss']
})
export class FacetCheckboxFilterComponent {
  @Input() loading: boolean;
  @Input() panel;
  @Input() activePanel = "";
  @Input() refreshCurrentPanel = false;
  @Input() facetData = {};
  @Input() cachedSelections = {};
  @Input() facetFilter ={};
  @Output() onCheckboxOptionChange: EventEmitter<any> = new EventEmitter();
  @Output() onCheckboxSwitchChange: EventEmitter<any> = new EventEmitter();

  ngOnChanges(changes) {

    console.log(changes);
  }
  customSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };
  onOptionChange(category, options) {
    this.onCheckboxOptionChange.emit({category, options})
  }
  onSwitchChange(event) {
    this.onCheckboxSwitchChange.emit(event);
  }
}
